import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {ReservedQrsService} from "../service/reserved-qrs-service";
import {RESERVED_IDENTIFICATION_ID} from "../constants/global.constants";
import {ReservedQrsResponse} from "../interface/reservedQrResponse";
import {statsErrorsToString} from "@angular-devkit/build-angular/src/tools/webpack/utils/stats";

@Component({
  selector: 'app-reserved-qr-cards',
  templateUrl: './reserved-qr-cards.component.html',
  styleUrl: './reserved-qr-cards.component.scss'
})
export class ReservedQrCardsComponent implements OnInit {

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private reservedQrsService: ReservedQrsService,
  ) {
  }

  ngOnInit() {
    const reservedIdentificationId = this.route.snapshot.paramMap.get(RESERVED_IDENTIFICATION_ID);
    if (!reservedIdentificationId) {
      this.router.navigate(['/error-page']);
      return;
    }

    this.reservedQrsService.getByReservedIdentificationId(reservedIdentificationId).subscribe({
      next: (response: ReservedQrsResponse) => {
        if (response.userCardQrUsername) {
          this.router.navigate(['/q', response.userCardQrUsername]);
          return;
        }
        response.isActiveCurrentUser
          ? this.router.navigate(['/active-business-card'], {state: {reservedIdentificationId: reservedIdentificationId}})
          : this.router.navigate(['/login'], {state: {reservedIdentificationId: reservedIdentificationId}});
      }
    })
  }
}
